import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

/**
 * Página exibida quando o usuário tenta acessar uma rota sem permissão.
 */
export default function NoAccess() {
  const [, setLocation] = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-center px-4">
      <div className="bg-orange-100 rounded-full p-6">
        <Lock className="w-12 h-12 text-orange-500" />
      </div>
      <h1 className="text-2xl font-bold text-gray-800">Acesso Negado</h1>
      <p className="text-gray-500 max-w-md">
        Você não tem permissão para acessar esta página. Entre em contato com o administrador do sistema para solicitar acesso.
      </p>
      <Button
        onClick={() => setLocation("/")}
        className="bg-orange-500 hover:bg-orange-600 text-white mt-2"
      >
        Voltar ao Início
      </Button>
    </div>
  );
}
